import emailjs from '@emailjs/browser';

// Initialize EmailJS with your public key
emailjs.init("JithCtl-KZ92asGlp");

export const EMAILJS_SERVICE_ID = "service_7ky3v7m";
export const EMAILJS_TEMPLATE_ID = "template_b0snugp";
export const EMAILJS_CONSULTATION_TEMPLATE_ID = "template_nqm7xz7";

export interface ProjectPlannerData {
  name: string;
  email: string;
  phone: string;
  service: string;
  description: string;
  propertyType: string;
  projectSize: string;
  timeline: string;
  hasMaterials: boolean;
  address: string;
  estimatedCost: string;
}

export interface ConsultationFormData {
  name: string;
  email: string;
  phone: string;
  service: string;
  location: string;
  budget: string;
  timeline: string;
  message: string;
}

export const sendProjectPlannerEmail = async (data: ProjectPlannerData) => {
  try {
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      {
        to_name: "Golden Touch Team",
        from_name: data.name,
        from_email: data.email,
        phone: data.phone,
        service: data.service,
        description: data.description,
        property_type: data.propertyType,
        project_size: data.projectSize,
        timeline: data.timeline,
        has_materials: data.hasMaterials ? "Yes" : "No",
        address: data.address,
        estimated_cost: data.estimatedCost
      }
    );
    return response;
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};

export const sendConsultationEmail = async (data: ConsultationFormData) => {
  try {
    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_CONSULTATION_TEMPLATE_ID,
      {
        from_name: data.name,
        from_email: data.email,
        phone: data.phone,
        service: data.service,
        location: data.location,
        budget: data.budget,
        timeline: data.timeline,
        message: data.message,
        to_name: "Golden Touch Team",
      }
    );
    return response;
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};